import React, { FC, useContext, useEffect, useState } from "react";
import Blade from "./Blade";
import useDeviceStore, { IGroupedDevices } from "common/store/DeviceStore";
import DeviceCategory from "common/constants/DeviceCategory";
import theme from "common/theme/theme";
import { LanguageContext } from "common/contexts/LanguageContext";
import useLookupsStore from "common/store/LookupsStore";
import { ObstructionMetaDeviceID } from "common/constants/GlobalValues";

const AvailableDevicesBlade: FC = () => {
  const [gatewayDevices, setGatewayDevices] = useState<IGroupedDevices[]>([]);
  const [otherDevices, setOtherDevices] = useState<IGroupedDevices[]>([]);
  const [outermostContainer, setOutermostContainer] = useState<IGroupedDevices[]>([]);
  const devices = useDeviceStore((state) => state.devices);
   const { getString } = useContext(LanguageContext);
  const { obstructionTypes } = useLookupsStore();

  useEffect(() => {
    const gatewayGroups = devices.filter(
      (d) => d.deviceCategoryID === DeviceCategory.Gateway || d.deviceCategoryID === DeviceCategory.Antenna,
    );
    let gatewayDevices: IGroupedDevices[] = [];
    gatewayGroups.forEach((item) => {
      gatewayDevices = [...gatewayDevices, ...item.children];
    });
    setGatewayDevices(gatewayDevices);
  }, [devices]);

  useEffect(() => {
    let otherDevices: IGroupedDevices[] = [];

    // First add in the obstruction types
    obstructionTypes?.forEach((item) => {
      otherDevices = [
        ...otherDevices,
        {
          name: item.obstructionTypeName,
          deviceID: ObstructionMetaDeviceID,
          deviceCategoryID: item.obstructionTypeID,
          detailUrl: null,
          imageUrl: item.obstructionImageUrl,
          image: null,
          description: null,
          children: [],
        },
      ];
    });

    setOtherDevices(otherDevices);
  }, [devices, obstructionTypes]);

  useEffect(() => {
    const outermostContainer: IGroupedDevices[] = [
      {
        name: getString("blade_add_gateway"),
        deviceID: -1,
        deviceCategoryID: -3,
        detailUrl: null,
        imageUrl: null,
        image: null,
        description: null,
        children: gatewayDevices,
      },
      {
        name: getString("blade_add_instruments"),
        deviceID: -1,
        deviceCategoryID: -2,
        detailUrl: null,
        imageUrl: null,
        image: null,
        description: null,
        children: devices.filter(
          (d) =>
            d.deviceCategoryID !== DeviceCategory.Gateway &&
            d.deviceCategoryID !== DeviceCategory.Antenna &&
            d.deviceCategoryID !== DeviceCategory.Other,
        ),
      },
      {
        name: getString("blade_add_other"),
        deviceID: -1,
        deviceCategoryID: -1,
        detailUrl: null,
        imageUrl: null,
        image: null,
        description: null,
        children: otherDevices,
      },
    ];

    setOutermostContainer(outermostContainer);
  }, [gatewayDevices, otherDevices, devices, getString]);

  return (
    <Blade groupedDevices={outermostContainer} bgColor={theme.palette.grey[50]} level={0} plusMinusIconLevel={0} />
  );
};

export default AvailableDevicesBlade;
